"use strict";

import axios from "axios";
import router from '../router/index';
import store from '../store/index';

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
	// baseURL: process.env.baseURL || process.env.apiUrl || ""
	// timeout: 60 * 1000, // Timeout
	withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
	function (config) {
		// Do something before request is sent
		return config;
	},
	function (error) {
		// Do something with request error
		return Promise.reject(error);
	}
);

// Add a response interceptor
_axios.interceptors.response.use(
	function (response) {
		// Do something with response data
		return response;
	},
	function (error) {
		
		let response = error.response;
		
		if (response.status === 401) {
			store.commit('user/setLoggedin', false);
			router.push({path: '/dashboard/login'});
			return Promise.reject("You have been logged out.")
		}
		
		// Do something with response error
		return Promise.reject(error);
	}
);

Plugin.install = function (Vue) {
	Vue.axios = _axios;
	window.axios = _axios;
	
	Object.defineProperties(Vue.prototype, {
		axios: {
			get() {
				return _axios;
			}
		},
		$axios: {
			get() {
				return _axios;
			}
		},
	});
};

export default Plugin;